// src/data/novosPontos.js
/**
 * Catálogo de novos pontos culturais com fotos verificadas e coordenadas de precisão.
 */

export const NOVOS_PONTOS_CULTURAIS = [
  {
    "id": 81100,
    "nome": "Pedra Grande de São José do Divino",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "São José do Divino",
    "municipios": [
      "São José do Divino"
    ],
    "descricao": "Imponente torre e monólito arenítico de cerca de 25 metros de altura localizado na localidade Jaburu, zona rural de São José do Divino. O ponto é palco de lendas populares sertanejas e proporciona uma vista espetacular da vegetação de transição e do relevo da região.",
    "lat": -3.79152,
    "lng": -41.80201,
    "local": "Localidade Jaburu - São José do Divino",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2018/10/pgsjd1.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2018/10/pgsjd2.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2018/10/pgsjd5.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Acervo Jaburu / F. Gerson Meneses",
    "image_status": "Novo"
  },
  {
    "id": 81107,
    "nome": "Sítio Arqueológico Pedra do Esqueleto",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "São José do Divino",
    "municipios": [
      "São José do Divino"
    ],
    "descricao": "Afloramento arenítico monumental com painel de gravuras e pinturas rupestres pré-históricas. Destaca-se uma das mais singulares figuras antropomorfas do norte do Piauí, conhecida localmente como Pedra do Esqueleto ou do Espírito.",
    "lat": -3.79694444444444,
    "lng": -41.76805555555556,
    "local": "Pedra do Esqueleto, Zona Rural - São José do Divino",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2018/09/pesq1.png",
      "https://portalpiracuruca.com/wp-content/uploads/2018/09/pesq2.png",
      "https://portalpiracuruca.com/wp-content/uploads/2018/09/pesq3.png"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Pesquisa Arqueológica do Piauí",
    "image_status": "Novo"
  },
  {
    "id": 81114,
    "nome": "Sítio Arqueológico da Malhadinha",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "São José do Divino",
    "municipios": [
      "São José do Divino"
    ],
    "descricao": "Sítio arqueológico de pinturas rupestres localizado às margens do Riacho Caldeirão. Abriga registros pré-históricos raros com mãos em negativo, figuras estelares e padrões geométricos de grande relevância científica e patrimonial.",
    "lat": -3.8241,
    "lng": -41.8155,
    "local": "Riacho Caldeirão, Localidade Malhadinha - São José do Divino",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2019/06/sitio_malhadinha.png",
      "https://portalpiracuruca.com/wp-content/uploads/2019/06/IMG_20190620_153905313_HDR_crgb-300x225.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2019/06/IMG_20190620_153854676_HDR_lds-300x225.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Projeto Artes do Bitorocaia",
    "image_status": "Novo"
  },
  {
    "id": 81121,
    "nome": "Praça Manoel Divino e Centro Cívico",
    "categoria": "lazer",
    "categorias": [
      "Lazer",
      "Cultural",
      "Novo"
    ],
    "municipio": "São José do Divino",
    "municipios": [
      "São José do Divino"
    ],
    "descricao": "Principal centro cívico e de convivência social de São José do Divino, localizado no coração da cidade. Espaço arborizado que abriga apresentações culturais, feiras populares e as festividades oficiais do município.",
    "lat": -3.8105,
    "lng": -41.8295,
    "local": "Av. Manoel Divino, Centro - São José do Divino",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://saojosedodivino.pi.gov.br/wp-content/uploads/2026/09/site-SJD-2-1024x576.png",
      "https://saojosedodivino.pi.gov.br/wp-content/uploads/2026/09/Festival-1024x576.png",
      "https://saojosedodivino.pi.gov.br/wp-content/uploads/2026/09/site-SJD-7-1024x576.png"
    ],
    "videos": [],
    "creditos_foto": "Prefeitura Municipal de São José do Divino",
    "image_status": "Novo"
  },
  {
    "id": 81128,
    "nome": "Casarão da Fazenda Belmonte",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "São João da Fronteira",
    "municipios": [
      "São João da Fronteira"
    ],
    "descricao": "Histórico casarão colonial construído com alvenaria de pedra no período do ciclo do gado no Piauí. Testemunho vivo da arquitetura sertaneja dos séculos XVIII e XIX e importante entreposto na antiga rota dos comboieiros da serra.",
    "lat": -4.0512,
    "lng": -41.489,
    "local": "Fazenda Belmonte, Povoado Alto Alegre - São João da Fronteira",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2020/03/03_casa-e1584472345432.png",
      "https://portalpiracuruca.com/wp-content/uploads/2020/03/06_ant-300x169.png",
      "https://portalpiracuruca.com/wp-content/uploads/2020/03/23-ant.png"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Acervo Histórico Belmonte",
    "image_status": "Novo"
  },
  {
    "id": 81135,
    "nome": "Sítio Arqueológico Arataca (Pedra Ferrada)",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "São João da Fronteira",
    "municipios": [
      "São João da Fronteira"
    ],
    "descricao": "Sítio com extenso paredão rochoso com arte rupestre na Serra da Ibiapaba. Exibe gravuras conhecidas como 'ferraduras' e grafismos pré-históricos catalogados em expedições arqueológicas do norte piauiense.",
    "lat": -3.918,
    "lng": -41.205,
    "local": "Localidade Arataca, Serra da Ibiapaba - São João da Fronteira",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2019/12/WhatsApp-Image-2019-12-15-at-12.01.56.jpeg",
      "https://portalpiracuruca.com/wp-content/uploads/2019/12/IMG_0792.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2019/12/IMG_20191215_131012632.jpg"
    ],
    "videos": [],
    "creditos_foto": "Expedição Arataca / Portal Piracuruca",
    "image_status": "Novo"
  },
  {
    "id": 81142,
    "nome": "Sítio Arqueológico Pés de Ema",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "São João da Fronteira",
    "municipios": [
      "São João da Fronteira"
    ],
    "descricao": "Situado às margens do Riacho do Pintado na localidade Lagoa de Cima, o sítio apresenta impressionantes painéis com pegadas tridáctilas de ema gravadas na rocha, típicas da tradição arqueológica do norte do Brasil.",
    "lat": -3.9352,
    "lng": -41.2415,
    "local": "Riacho do Pintado, Lagoa de Cima - São João da Fronteira",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca01.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca04.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca03.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Expedição Caminhos da Ibiapaba",
    "image_status": "Novo"
  },
  {
    "id": 81149,
    "nome": "Mirante da Serra Grande",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "São João da Fronteira",
    "municipios": [
      "São João da Fronteira"
    ],
    "descricao": "Mirante natural situado na crista da Serra Grande, na fronteira entre os estados do Piauí e Ceará. Apresenta vista panorâmica dos vales do sertão, brisa constante e trilhas ecológicas de contemplação da caatinga.",
    "lat": -3.948,
    "lng": -41.221,
    "local": "Serra Grande - São João da Fronteira",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca06.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca07.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca08.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Ecoturismo Piauí",
    "image_status": "Novo"
  },
  {
    "id": 81156,
    "nome": "Cachoeira e Balneário do Rio Parafuso",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Milton Brandão",
    "municipios": [
      "Milton Brandão"
    ],
    "descricao": "Belíssima queda d'água perene e banho natural em leito rochoso de arenito no leito do Rio Parafuso. O local atrai amantes do ecoturismo, banhistas e trilheiros em busca de contato com as águas cristalinas do município.",
    "lat": -4.662,
    "lng": -41.455,
    "local": "Rio Parafuso, Zona Rural - Milton Brandão",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto04.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto01.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto02.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Expedição Milton Brandão",
    "image_status": "Novo"
  },
  {
    "id": 81163,
    "nome": "Sítio Arqueológico Serra da Andorinha",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "Milton Brandão",
    "municipios": [
      "Milton Brandão"
    ],
    "descricao": "Abrigo sob rocha de rara beleza cênica contendo pinturas rupestres pré-históricas em tons avermelhados e ocres, inserido na formação rochosa da Serra da Andorinha com rica biodiversidade vegetal.",
    "lat": -4.671,
    "lng": -41.412,
    "local": "Serra da Andorinha - Milton Brandão",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto05.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto06.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto07.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Projeto Artes do Bitorocaia",
    "image_status": "Novo"
  },
  {
    "id": 81170,
    "nome": "Mirante da Serra do Cruzeiro",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Religioso",
      "Novo"
    ],
    "municipio": "Milton Brandão",
    "municipios": [
      "Milton Brandão"
    ],
    "descricao": "Ponto culminante da área urbana de Milton Brandão, local de peregrinação religiosa e mirante natural que oferece vista panorâmica de 360 graus da cidade e das serras vizinhas.",
    "lat": -4.6885,
    "lng": -41.432,
    "local": "Serra do Cruzeiro - Milton Brandão",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto09.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto10.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto03.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Acervo Municipal de Milton Brandão",
    "image_status": "Novo"
  },
  {
    "id": 81177,
    "nome": "Mirante e Formação da Pedra da Lua",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Domingos Mourão",
    "municipios": [
      "Domingos Mourão"
    ],
    "descricao": "Singular afloramento geológico com alvéolos e depressões erosivas circulares que lembram crateras lunares na Comunidade Criolo. O local funciona como mirante natural para os relevos da bacia do Rio Piracuruca.",
    "lat": -4.3218,
    "lng": -41.425,
    "local": "Comunidade Criolo - Domingos Mourão",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp04.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp05.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp06.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Expedição João de Britto Passos",
    "image_status": "Novo"
  },
  {
    "id": 81184,
    "nome": "Casarão e Fazenda Histórica Dois Riachos",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "Domingos Mourão",
    "municipios": [
      "Domingos Mourão"
    ],
    "descricao": "Propriedade histórica com arquitetura colonial campestre preservada, marcando a colonização pastoril dos vales de Domingos Mourão e conservando utensílios e construções de época.",
    "lat": -4.312,
    "lng": -41.385,
    "local": "Fazenda Dois Riachos - Domingos Mourão",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp01.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp02.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp07.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Acervo Dois Riachos",
    "image_status": "Novo"
  },
  {
    "id": 81191,
    "nome": "Praça da Matriz e Centro Religioso",
    "categoria": "cultural",
    "categorias": [
      "Cultural",
      "Lazer",
      "Novo"
    ],
    "municipio": "Domingos Mourão",
    "municipios": [
      "Domingos Mourão"
    ],
    "descricao": "Coração urbano e social de Domingos Mourão, onde se realizam os tradicionais festejos de Nossa Senhora do Carmo. Ponto de encontro acolhedor com arborização típica e áreas de convivência comunitária.",
    "lat": -4.26937563299685,
    "lng": -41.35965035329575,
    "local": "Praça da Matriz, Centro - Domingos Mourão",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp09.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp10.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp11.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Comunidade de Domingos Mourão",
    "image_status": "Novo"
  },
  {
    "id": 81198,
    "nome": "Monumento de São Francisco de Assis (Orla)",
    "categoria": "religioso",
    "categorias": [
      "Religioso",
      "Turistico",
      "Novo"
    ],
    "municipio": "Lagoa de São Francisco",
    "municipios": [
      "Lagoa de São Francisco"
    ],
    "descricao": "Monumento esculpido do padroeiro erguido em destaque na orla da lagoa municipal. Principal cartão-postal da cidade, procurado para contemplação do entardecer e devoção franciscana.",
    "lat": -4.33259717910265,
    "lng": -41.58369332192976,
    "local": "Orla da Lagoa - Lagoa de São Francisco",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth01-3.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth02.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth03.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Expedição ROTHAM",
    "image_status": "Novo"
  },
  {
    "id": 81205,
    "nome": "Aldeia Nazaré (Povo Indígena Tabajara)",
    "categoria": "cultural",
    "categorias": [
      "Cultural",
      "Historico",
      "Novo"
    ],
    "municipio": "Lagoa de São Francisco",
    "municipios": [
      "Lagoa de São Francisco"
    ],
    "descricao": "Território tradicional e comunidade indígena do povo Tabajara em Lagoa de São Francisco. Polo de valorização da identidade originária, ritos ancestrais, artesanato indígena e preservação ambiental.",
    "lat": -4.354,
    "lng": -41.602,
    "local": "Comunidade Nazaré - Lagoa de São Francisco",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth04.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth05.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth06.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Comunidade Indígena Tabajara",
    "image_status": "Novo"
  },
  {
    "id": 81212,
    "nome": "Estação Ferroviária Histórica de Capitão de Campos",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "Capitão de Campos",
    "municipios": [
      "Capitão de Campos"
    ],
    "descricao": "Estação ferroviária da Estrada de Ferro Central do Piauí inaugurada na década de 1930. Prédio histórico que marcou a chegada do transporte ferroviário e originou o povoamento central de Capitão de Campos.",
    "lat": -4.451034185913458,
    "lng": -41.95038627220894,
    "local": "Rua da Estação, Centro - Capitão de Campos",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2025/09/mat_cc.png",
      "https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta2.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta1.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Patrimônio Ferroviário do Piauí",
    "image_status": "Novo"
  },
  {
    "id": 81219,
    "nome": "Sítio Arqueológico Pedra do Letreiro",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "Capitão de Campos",
    "municipios": [
      "Capitão de Campos"
    ],
    "descricao": "Conjunto de gravuras rupestres sobre lajedo de arenito nas proximidades do Riacho do Jacu. Apresenta inscrições pré-coloniais protegidas pela mata nativa, de elevado valor arqueológico regional.",
    "lat": -4.585,
    "lng": -41.832,
    "local": "Riacho do Jacu, Zona Rural - Capitão de Campos",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta3.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta4.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta5.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Acervo Capitão de Campos",
    "image_status": "Novo"
  },
  {
    "id": 81226,
    "nome": "Complexo do Rio Longá e Balneário de Batalha",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Batalha",
    "municipios": [
      "Batalha"
    ],
    "descricao": "Área de banho e lazer natural formada pelas águas correntes do Rio Longá em Batalha. Possui vegetação ciliar preservada, bancos de areia e infraestrutura de acolhimento turístico.",
    "lat": -4.0265,
    "lng": -42.074,
    "local": "Margens do Rio Longá - Batalha",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca11.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca12.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca13.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Ecoturismo Vale do Longá",
    "image_status": "Novo"
  },
  {
    "id": 81233,
    "nome": "Paisagens e Cultura Tradicional de Batalha",
    "categoria": "cultural",
    "categorias": [
      "Cultural",
      "Turistico",
      "Novo"
    ],
    "municipio": "Batalha",
    "municipios": [
      "Batalha"
    ],
    "descricao": "Circuito cultural e paisagístico destacando os caminhos históricos de Batalha, a cultura do vaqueiro piauiense tradicional com vestimentas de couro autênticas e a expressividade da bacia do Longá.",
    "lat": -4.028,
    "lng": -42.082,
    "local": "Circuito Histórico e Cultural - Batalha",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth08.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth09.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/04/roth10.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Expedição ROTHAM Piauí",
    "image_status": "Novo"
  },
  {
    "id": 81240,
    "nome": "Barragem de Piracuruca (Grande Lago)",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Piracuruca",
    "municipios": [
      "Piracuruca"
    ],
    "descricao": "O Grande Lago da Barragem de Piracuruca é o principal polo hídrico e esportivo do norte piauiense. Oferece passeios de caiaque, pesca esportiva e cenários exuberantes entre paredões de arenito e águas calmas.",
    "lat": -4.0050486,
    "lng": -41.6169942,
    "local": "Grande Lago, Barragem - Piracuruca",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2024/08/expedlago05.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/08/expedlago06.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2024/08/expedlago08.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Expedição de Caiaque Grande Lago",
    "image_status": "Novo"
  },
  {
    "id": 81247,
    "nome": "Centro Histórico e Casario Colonial (Piracuruca - IPHAN)",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "Piracuruca",
    "municipios": [
      "Piracuruca"
    ],
    "descricao": "Conjunto arquitetônico e urbanístico colonial tombado pelo IPHAN. Inclui a histórica Rua da Goela, calçamentos originais de pedra e casarios dos séculos XVIII e XIX que vivenciaram a Guerra do Fidié e a Balaiada.",
    "lat": -3.9285,
    "lng": -41.709,
    "local": "Rua da Goela, Centro Histórico - Piracuruca",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2026/08/guela1.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2026/08/guela2.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2026/08/guela3.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Acervo do Centro Histórico",
    "image_status": "Novo"
  },
  {
    "id": 81254,
    "nome": "Povoado Saco dos Polidórios e Trilhas Ecológicas",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Brasileira",
    "municipios": [
      "Brasileira"
    ],
    "descricao": "Comunidade tradicional no município de Brasileira que abriga trilhas ecológicas, lajedos de arenito com arte rupestre preservada e rica diversidade da avifauna da transição caatinga-cerrado.",
    "lat": -4.115,
    "lng": -41.758,
    "local": "Povoado Saco dos Polidórios - Brasileira",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://portalpiracuruca.com/wp-content/uploads/2026/02/rsmoprin.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2026/02/matros01.jpg",
      "https://portalpiracuruca.com/wp-content/uploads/2026/02/DJI_0226.jpg"
    ],
    "videos": [],
    "creditos_foto": "Portal Piracuruca / Comunidade Saco dos Polidórios",
    "image_status": "Novo"
  },
  {
    "id": 81261,
    "nome": "Espaço Cultural do Reisado e Arena dos Reis",
    "categoria": "cultural",
    "categorias": [
      "Cultural",
      "Festivo",
      "Novo"
    ],
    "municipio": "Boa Hora",
    "municipios": [
      "Boa Hora"
    ],
    "descricao": "Palco central do tradicional Festival de Reisado de Boa Hora, manifestação consagrada como Patrimônio Cultural Imaterial do Piauí. O espaço reúne anualmente milhares de pessoas no ciclo de Reis com apresentações dos grupos de caretas, mandadores, sanfoneiros e a emblemática 'morte do boi'.",
    "lat": -4.40885104368238,
    "lng": -42.10175174334713,
    "local": "Arena do Reisado, Centro - Boa Hora",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://boahora.pi.gov.br/wp-content/uploads/2025/12/Reisado-2026.png",
      "https://boahora.pi.gov.br/wp-content/uploads/2025/12/Reisado-2025-Prepare-se.jpeg",
      "https://boahora.pi.gov.br/wp-content/uploads/2025/07/Cultura-Boa-Hora-Valorizacao-scaled.jpg"
    ],
    "videos": [],
    "creditos_foto": "Prefeitura Municipal de Boa Hora / Secretaria de Cultura",
    "image_status": "Novo"
  },
  {
    "id": 81268,
    "nome": "Igreja Matriz de São Pedro e Praça Central",
    "categoria": "religioso",
    "categorias": [
      "Religioso",
      "Cultural",
      "Novo"
    ],
    "municipio": "Boa Hora",
    "municipios": [
      "Boa Hora"
    ],
    "descricao": "Templo sede da fé católica de Boa Hora em honra a São Pedro, padroeiro da cidade. Ponto de encontro comunitário que acolhe os tradicionais festejos de São Pedro e celebrações religiosas no coração do município.",
    "lat": -4.40912,
    "lng": -42.10235,
    "local": "Praça da Matriz, Centro - Boa Hora",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://upload.wikimedia.org/wikipedia/commons/7/7c/Igreja_Matriz_de_Boa_Hora_Piau%C3%AD_em_dezembro_de_2018.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/f/f3/Igreja_Matriz_de_Boa_Hora.JPG",
      "https://boahora.pi.gov.br/wp-content/uploads/2026/05/festa-encerramento-1-831x1024.jpeg"
    ],
    "videos": [],
    "creditos_foto": "Acervo Comunitário / Wikimedia Commons / Prefeitura de Boa Hora",
    "image_status": "Novo"
  },
  {
    "id": 81275,
    "nome": "Rota dos Engenhos Tradicionais e Produção de Rapadura",
    "categoria": "cultural",
    "categorias": [
      "Cultural",
      "Turistico",
      "Novo"
    ],
    "municipio": "Boa Hora",
    "municipios": [
      "Boa Hora"
    ],
    "descricao": "Boa Hora é consagrada como a Capital da Rapadura no Piauí, abrigando cerca de 150 engenhos artesanais ativos. O circuito dos engenhos preserva técnicas seculares de moagem de cana-de-açúcar, cozimento em tachos de cobre e produção de rapaduras tradicionais e com castanha, coco e amendoim.",
    "lat": -4.415,
    "lng": -42.095,
    "local": "Circuito dos Engenhos, Zona Rural - Boa Hora",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://upload.wikimedia.org/wikipedia/commons/3/34/Rapadura_de_Boa_Hora-PI.JPG",
      "https://boahora.pi.gov.br/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-15-at-10.51.10.jpeg",
      "https://boahora.pi.gov.br/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-15-at-10.51.11-3.jpeg"
    ],
    "videos": [],
    "creditos_foto": "Cooperativa dos Produtores de Boa Hora / Acervo Piauí",
    "image_status": "Novo"
  },
  {
    "id": 81282,
    "nome": "Biblioteca Pública e Memorial Cultural de Boa Hora",
    "categoria": "cultural",
    "categorias": [
      "Cultural",
      "Historico",
      "Novo"
    ],
    "municipio": "Boa Hora",
    "municipios": [
      "Boa Hora"
    ],
    "descricao": "Espaço público voltado à guarda da memória documental e literária do município de Boa Hora. Abriga acervo bibliográfico, exposições temporárias e iniciativas de incentivo à leitura e preservação das histórias orais dos mestres de reisado e agricultores locais.",
    "lat": -4.4085,
    "lng": -42.1012,
    "local": "Rua do Centro Cívico - Boa Hora",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://upload.wikimedia.org/wikipedia/commons/5/58/Biblioteca_Municipal_de_Boa_Hora_Piau%C3%AD.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/f/f8/Biblioteca_de_Boa_Hora_Piau%C3%AD.JPG",
      "https://upload.wikimedia.org/wikipedia/commons/9/94/Rua_de_BH_Piau%C3%AD.JPG"
    ],
    "videos": [],
    "creditos_foto": "Acervo Municipal / Wikimedia Commons / Antonio Filho Piauiense",
    "image_status": "Novo"
  },
  {
    "id": 81289,
    "nome": "Igreja Matriz de Nossa Senhora da Conceição e Praça Monsenhor Boson",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Religioso",
      "Novo"
    ],
    "municipio": "Barras",
    "municipios": [
      "Barras"
    ],
    "descricao": "Marco histórico e espiritual da cidade de Barras, com paróquia criada em 1840 às margens do Rio Marataoan. O templo imponente e a aprazível Praça Monsenhor Boson e Praça Senador Joaquim Pires constituem o núcleo histórico colonial e cultural da 'Terra dos Governadores'.",
    "lat": -4.19306785213745,
    "lng": -42.42058760369454,
    "local": "Praça Senador Joaquim Pires, 108, Centro - Barras",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://upload.wikimedia.org/wikipedia/commons/1/10/Igreja_Matriz_de_Barras_Piau%C3%AD..jpg",
      "https://www.barras.pi.gov.br/wp-content/uploads/2024/11/praca.jpg",
      "https://www.barras.pi.gov.br/wp-content/uploads/2024/06/praca.jpg"
    ],
    "videos": [],
    "creditos_foto": "Wikimedia Commons / Prefeitura Municipal de Barras",
    "image_status": "Novo"
  },
  {
    "id": 81296,
    "nome": "Orla do Rio Marataoan e Parque Fluvial",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Barras",
    "municipios": [
      "Barras"
    ],
    "descricao": "Principal cartão-postal natural de Barras, a orla urbanizada do Rio Marataoan proporciona um amplo espaço de lazer, passeios ao entardecer, gastronomia regional e eventos culturais como o Orla Festival. O rio é a artéria vital que moldou a identidade ribeirinha da cidade.",
    "lat": -4.1915,
    "lng": -42.4182,
    "local": "Orla Fluvial, Bairro Beira Rio - Barras",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://longah.com/envios/2025/12/22/c6cd46e41d5f5f4e7bbe0258d9239edf3bd833ed.webp",
      "https://longah.com/envios/2025/12/22/ac9abecbeffb84c61ab3f7344e7a4c392db23c64.webp",
      "https://longah.com/envios/2025/12/22/b4d3c3d84d900883fda26fe444b9e41579dbae0c.webp"
    ],
    "videos": [],
    "creditos_foto": "Portal Longah / Acervo de Barras",
    "image_status": "Novo"
  },
  {
    "id": 81303,
    "nome": "Circuito de Turismo Rural e Ecoturismo dos Morros",
    "categoria": "turistico",
    "categorias": [
      "Turistico",
      "Lazer",
      "Novo"
    ],
    "municipio": "Barras",
    "municipios": [
      "Barras"
    ],
    "descricao": "Circuito ecológico e de turismo rural composto pelos relevos e formações areníticas da bacia do Longá e Marataoan em Barras. Oferece trilhas ecológicas, mirantes naturais para a caatinga e vivência direta com as práticas agrícolas e pastoris do interior barrense.",
    "lat": -4.205,
    "lng": -42.435,
    "local": "Polo Rural e Morros, Zona Rural - Barras",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://longah.com/envios/2026/04/21/dbde0ec981b22ffc31332ad794f096dc6f95d59a.webp",
      "https://longah.com/envios/2026/04/21/f4dd701ff1c051666a8c2f934887af49db55f48b.webp",
      "https://longah.com/envios/2026/04/21/cc63c7b4efabe30a8c068486dfdcfad9affc0283.webp"
    ],
    "videos": [],
    "creditos_foto": "Secretaria de Turismo e Desenvolvimento Rural de Barras / Longah",
    "image_status": "Novo"
  },
  {
    "id": 81310,
    "nome": "Centro Histórico e Memória Barrense",
    "categoria": "historico",
    "categorias": [
      "Historico",
      "Cultural",
      "Novo"
    ],
    "municipio": "Barras",
    "municipios": [
      "Barras"
    ],
    "descricao": "Conjunto arquitetônico tradicional de Barras preservando casarios e sobrados do ciclo do algodão e da pecuária piauiense. O centro histórico evoca a memória dos governadores e intelectuais da cidade e celebra personalidades históricas que marcaram a formação do Piauí.",
    "lat": -4.1942,
    "lng": -42.4215,
    "local": "Centro Histórico, Ruas Centrais - Barras",
    "participantes": 0,
    "color": "#06b6d4",
    "fotos": [
      "https://upload.wikimedia.org/wikipedia/commons/7/7e/Miniatura_de_Barras_no_Piau%C3%AD_2.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/f/fe/Miniatura_de_Barras_no_Piau%C3%AD.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/c/cf/Onibus_do_General_-_Barras_-_PI..jpg"
    ],
    "videos": [],
    "creditos_foto": "Academia de Letras / Wikimedia Commons / Acervo Histórico de Barras",
    "image_status": "Novo"
  }
];
